import * as React from 'react';
import { SelectProps } from '../antd/Select/Select';
import CreditCardsEmpty from '../CreditCards/CreditCardsEmpty';
import CreditCardForm from '../CreditCards/CreditCardForm';
import styles from './CCSelect.module.scss';
import { ReactStripeElements } from 'react-stripe-elements';
import { Alert, Select } from 'components/antd';

import { BookingCreditCard } from 'app-types';
import classNames from 'classnames';
import { ThemeContext } from 'app-themes';
import { SelectValue } from 'antd/lib/select';
import CCDisplay from './CCDisplay';
import { FetchStatus } from 'servicesCommon/apiTypes';

interface State {
	isFormHidden?: boolean;
}
interface Props extends SelectProps {
	creditCards: BookingCreditCard[];
	oneTimeCreditCards: BookingCreditCard[];
	containerName: string;
	isSelectCardType?: boolean;
	fetchStatus?: FetchStatus;
	warningMessage?: string;

	setBookingCardId: (creditCardId: string | number | undefined, isOneTime?: boolean) => void;
	addOneTimeCard: (
		stripe: ReactStripeElements.StripeProps,
		cardElement: stripe.elements.Element
	) => void;
}

export default class CCSelect extends React.Component<Props, State> {
	static contextType = ThemeContext;

	state = {
		isFormHidden: true,
	};

	onSelect = (value: SelectValue) => {
		const val = value as string | number | undefined;
		if (val === 'addOnetime') {
			this.setState({
				isFormHidden: false,
			});
		} else {
			const isOneTime = typeof val === 'string';
			this.props.setBookingCardId(val, isOneTime);
		}
	};

	render() {
		const { isFormHidden } = this.state;
		const {
			creditCards,
			oneTimeCreditCards,
			containerName,
			isSelectCardType,
			fetchStatus,
			value,
			warningMessage,
			...restProps
		} = this.props;
		const theme = this.context;

		return (
			<div id={`cc-${containerName}`} className={styles.ccSelectContainer}>
				{isFormHidden && (
					<>
						<div className={styles.bookingCardTitle}>Credit card</div>

						<Select
							optionFilterProp="children"
							placeholder={<CreditCardsEmpty />}
							getPopupContainer={() =>
								document.getElementById(`cc-${containerName}`) || document.body
							}
							filterOption={(input: any, option: any) =>
								option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
								0
							}
							className={classNames(styles.ccSelect, {
								[styles.ccSelectType]: isSelectCardType,
								[styles[`ccSelect-${theme}`]]: theme !== '',
							})}
							dropdownClassName={styles.ccDropdown}
							onSelect={this.onSelect}
							value={value}
							{...restProps}
						>
							<Select.OptGroup label="Saved cards" key="1">
								{creditCards.length > 0 ? (
									creditCards.map((item: any) => (
										<Select.Option
											key={item.customerUserCreditCardId}
											value={item.customerUserCreditCardId}
											className={styles.ccOption}
										>
											<CCDisplay creditCard={item} />
										</Select.Option>
									))
								) : (
									<Select.Option value={undefined} key="noCard" disabled>
										<CreditCardsEmpty />
									</Select.Option>
								)}
							</Select.OptGroup>
							{oneTimeCreditCards.length > 0 && (
								<Select.OptGroup label="One-time cards" key="2">
									{oneTimeCreditCards.map((item: any) => (
										<Select.Option
											key={item.customerUserCreditCardId}
											value={item.customerUserCreditCardId}
											className={styles.ccOption}
										>
											<CCDisplay creditCard={item} />
										</Select.Option>
									))}
								</Select.OptGroup>
							)}
							<Select.Option
								value="addOnetime"
								key="oneTimeCard"
								className={styles.ccOptionAdd}
							>
								+ Add one-time card
							</Select.Option>
						</Select>
						{warningMessage && <Alert type="info" message={warningMessage} showIcon />}
					</>
				)}

				<CreditCardForm
					isHidden={isFormHidden}
					hideCreditCard={() => {
						this.setState({
							isFormHidden: true,
						});
					}}
					saveCreditCard={this.props.addOneTimeCard}
					fetchStatus={fetchStatus}
				/>
			</div>
		);
	}
}
